import { EntGovernment } from "./government";


export class EntDepartment {
  id: number | null = null;
  nameRu: string | null = null;
  nameKy: string | null = null;
  parentId?: string | null = null;
  government?: EntGovernment | null = null;
  governmentId?: EntGovernment | null = null;
}
